import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-like-coupon-carousel',
  templateUrl: './like-coupon-carousel.component.html',
  styleUrls: ['./like-coupon-carousel.component.scss']
})
export class LikeCouponCarouselComponent implements OnInit {
  @Input() itemsCoreData: { activeItems: any, noActiveItems: any, type?: number };
  @Input() mantenienceSection;
  @Output() sectionAvailability: EventEmitter<any> = new EventEmitter<any>();
  @Output() sectionCreate: EventEmitter<any> = new EventEmitter<any>();
  @Output() sectionDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() sectionEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemAvailability: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemCreate: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() insertPdf: EventEmitter<any> = new EventEmitter<any>();
  @Input() isBenefit = false;
  currentDate: any;

  constructor() {
  }

  ngOnInit(): void {    
    this.currentDate = new Date();
  }

  sendSectionAvailability(itemId: number): void {
    this.sectionAvailability.emit(itemId);
  }

  sendSectionCreate(): void {
    this.sectionCreate.emit(true);
  }

  sendSectionDelete(itemId: any): void {
    this.sectionDelete.emit(itemId);
  }

  sendSectionEdit(item: any): void {
    const toSendItem = {
      id: item.sectionId,
      order: item.orderId,
      title: item.section,
      visibleCarousel : item.visibleCarousel,
      visibleFilter : item.visibleFilter
    };
    this.sectionEdit.emit(toSendItem);
  }

  sendItemAvailability(itemId: number, categoryId: number, itemName: string): void {
    this.itemAvailability.emit({id: itemId, sectionId: categoryId, name: itemName});
  }

  sendItemCreate(item: any): void {
    this.itemCreate.emit(item.sectionId);
  }

  sendItemEdit(item: any): void {
    this.itemEdit.emit(item);
  }

  sendItemDelete(itemId: number, categoryId: number, itemName: string) {
    this.itemDelete.emit({id: itemId, sectionId: categoryId, name: itemName});
  }

  insertBenefitPdf(itemId: number) {
    this.insertPdf.emit(itemId);
  }

  convertToDate(str: string) {
    return new Date(str);
  }
}
